import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  loadingById: false,
  saveLoading: false,
  saveLoadingById: false,
  preparationsLength: 0,
  preparations: [],
  preparation: {},
  preparationError: "",
  formError: "",
};

export default function PreparationReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADING_PREPARATION:
      return { ...state, loading: action.payload };
    case actions.LOADING_PREPARATION_BY_ID:
      return { ...state, loadingById: action.payload };
    case actions.SAVE_LOADING_PREPARATION:
      return { ...state, saveLoading: action.payload };
    case actions.SAVE_LOADING_PREPARATION_BY_ID:
      return { ...state, saveLoadingById: action.payload };
    case actions.GET_PREPARATION:
      return {
        ...state,
        preparations: action.payload.preparations,
        preparationsLength: action.payload.preparationsLength,
      };
    case actions.GET_PREPARATION_BY_ID:
      return {
        ...state,
        preparation: action.payload,
      };
    case actions.FORM_FAIL_PREPARATION:
      return { ...state, formError: action.payload };
    case actions.PREPARATION_FAIL:
      return { ...state, preparationError: action.payload };
    default:
      return state;
  }
}
